<div class="rendelo-list-page">

    <!-- TOP ROW: Komplexumok (1) + Helyszínek (3) side by side -->
    <div class="top-row">

        <mat-card class="komplexumok-card">
            <mat-card-header>
                <mat-card-title>Komplexumok</mat-card-title>
                <div class="spacer"></div>
                <div class="action-buttons">
                </div>
            </mat-card-header>
            <mat-card-content>
                <div class="data-placeholder">
                    <ag-grid-angular class="ag-theme-alpine"
                                     style="width: auto; height: 100%;"
                                     [columnDefs]="colDefs"
                                     [rowData]="komplexumok()"
                                     [rowSelection]="rowSelectionConfig"
                                     (gridReady)="onGridReady($event)"
                                     (selectionChanged)="onSelectionChanged($event)">
                    </ag-grid-angular>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card class="helyszinek-card">
            <mat-card-header>
                <mat-card-title>
                    {{ selectedKomplexum ? (selectedKomplexum.nev + ' – Helyszínek') : 'Helyszínek' }}
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                @if (!selectedKomplexum) {
                    <div class="no-data-container">
                        <mat-icon>business</mat-icon>
                        <p>Válasszon komplexumot a helyszínek megjelenítéséhez</p>
                    </div>
                } @else if (helysegekLoading) {
                    <div class="loading-container">
                        <mat-spinner diameter="40"></mat-spinner>
                    </div>
                } @else {
                    <div class="data-placeholder">
                        <ag-grid-angular class="ag-theme-alpine"
                                         style="width: auto; height: 100%;"
                                         [columnDefs]="helysegColDefs"
                                         [rowData]="helysegek"
                                         [rowSelection]="helysegRowSelectionConfig"
                                         (selectionChanged)="onHelyszinSelectionChanged($event)">
                        </ag-grid-angular>
                    </div>
                }
            </mat-card-content>
        </mat-card>

    </div>

    <!-- BOTTOM: Weekly calendar for selected helyszín -->
    <mat-card class="calendar-card">
        <mat-card-header>
            <mat-card-title>
                {{ selectedHelyszin ? (selectedHelyszin.nev + ' – Naptár') : 'Helyszín naptár' }}
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            @if (selectedHelyszin) {
                <full-calendar [options]="calendarOptions"></full-calendar>
            } @else {
                <div class="no-data-container">
                    <mat-icon>event</mat-icon>
                    <p>Válasszon helyszínt a naptár megjelenítéséhez</p>
                </div>
            }
        </mat-card-content>
    </mat-card>

</div>
